import angular from 'angular';
import uiRouter from 'angular-ui-router';
import { SYS_ADMIN } from 'config/permissions/roles';
import administrationsComponent from './admins-by-category-area.component';
import adminsByCategoryService from './admins-by-category-area.service';

export default
  angular.module('components.reports.administrationsByCategoryArea', [
    uiRouter
  ])
    .component('administrationsByCategoryArea', administrationsComponent)
    .service('AdminsByCategoryAreaService', adminsByCategoryService)
    .config(($stateProvider) => {
      'ngInject';

      $stateProvider
        .state('administrationsByCategoryArea', {
          parent: 'reports',
          url: '/administrations-by-category-area',
          component: 'administrationsByCategoryArea',
          data: {
            permissions: {
              only: [SYS_ADMIN],
              redirectTo: 'dashboard'
            }
          }
        });
    })
    .name;



// WEBPACK FOOTER //
// ./components/app/reports/admins-by-category-area/admins-by-category-area.module.js